import React from 'react'
import './ActionPage.css'

const ActionPage = () => {
  return (
    <div className='actionPage__container'>
      <div className='actionPage__reg'>
      <p>Request Early Access to Get Started</p>
      <h2>Register today & start exploring the endless possiblities.</h2>
      </div>
      <div className='action__btn'>
      <button >Get Started</button>
      </div>
    </div>
  )
}

export default ActionPage
